<template>
  <div>
    <div class="reg-success-label">
      <div class="panel panel-default reg-success">
        <div class="panel-body">
          <h3 class="text-center">Ваш аккаунт заблокирован!</h3>
          <p>
            Видимо что-то пошло не так и мы заблокировали ваш аккаунт, письмо с
            объеснением причин отправлено на вашу почту.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mainMixin from '@/common/mixins/mainMixin'

export default {
  name: 'Blocked',
  mixins: [mainMixin],

  mounted () {
    this.hidePreloader()
  }
}
</script>
